<template>
    <b-container fluid>
        <b-row row wrap align-v="end">
            <b-col cols="12" md="3">
                <b-btn variant="primary" @click="openForm" block
                    ><i class="fa fa-plus"></i> Crear Ronda</b-btn
                >
            </b-col>
            <b-col cols="12" md="3">
                <b-btn variant="primary" block @click="setupPoint">
                    <i class="fa fa-camera"></i>
                    Configurar Punto
                </b-btn>
            </b-col>
        </b-row>
        <b-row row wrap>
            <app-round-filters @filter="onFilter" />
        </b-row>
        <b-row row wrap>
            <b-col cols="12" v-if="!!roundsData">
                <app-rounds-list
                    :table-data="roundsData"
                    @sort="onSort"
                    @changePage="onChangePage"
                    @delete="deleteRound"
                    @edit="onEdit"
                ></app-rounds-list>
            </b-col>
        </b-row>
        <app-pop-up
            id="round-form-window"
            :title="`Nueva ronda para ${selectedClientName}`"
            size="large"
            :on-close="restartRoundForm"
        >
            <template slot="body">
                <app-round-config-form
                    ref="roundConfigForm"
                    @onSave="closeRoundFormWindow"
                ></app-round-config-form>
            </template>
            <template slot="buttons">
                <b-btn variant="confirm" @click="saveRound"
                    ><i class="fa fa-save"></i> Guardar Ronda</b-btn
                >
            </template>
        </app-pop-up>
        <app-pop-up
            id="control-point-config-window"
            title="Configuración de Punto de Control"
            :on-close="readerOff"
        >
            <template slot="body">
                <app-round-control-point-config
                    ref="controlPointReader"
                    @read="onRead"
                ></app-round-control-point-config>
            </template>
        </app-pop-up>
    </b-container>
</template>
<script>
import RoundsList from './RoundsList/RoundsList'
import RoundConfigForm from './RoundConfigForm/RoundConfigForm'
import { mapGetters } from 'vuex'
import roundsRepository from '@repositories/rounds.repository'
import RoundFilters from './RoundFilters/RoundFilters'
import RoundControlPointConfig from './RoundControlPointConfig/RoundControlPointConfig'

export default {
    components: {
        appRoundsList: RoundsList,
        appRoundConfigForm: RoundConfigForm,
        appRoundFilters: RoundFilters,
        appRoundControlPointConfig: RoundControlPointConfig,
    },
    data: () => ({
        roundsData: null,
        page: 1,
        sort: {
            sortBy: 'created_at',
            sortDir: 'desc',
        },
        filters: '',
    }),
    watch: {
        selectedClient(client) {
            this.loadRounds()
        },
    },
    computed: {
        selectedClientName() {
            return !!this.selectedClient ? this.selectedClient.name : ''
        },
    },
    methods: {
        onEdit(round) {
            this.$refs.roundConfigForm.fill(round)
            this.$bus.$emit('round-form-window.open')
        },
        openForm() {
            this.$refs.roundConfigForm.reset()
            this.$bus.$emit('round-form-window.open')
        },
        saveRound() {
            this.$refs.roundConfigForm.save()
        },
        restartRoundForm() {
            this.$refs.roundConfigForm.reset()
        },
        closeRoundFormWindow() {
            this.$bus.$emit('round-form-window.close')
            this.loadRounds()
        },
        async loadRounds() {
            const rr = { ...roundsRepository }
            try {
                const params = {
                    page: this.page,
                    ...this.sort,
                    ...this.filters,
                }
                const { data } = await rr.get(params)
                this.roundsData = data
            } catch (err) {
                toastr.error(
                    `Ocurrió un error al cargar las rondas [${err.message}]`
                )
            }
        },
        onSort(ctx) {
            this.sort = ctx
            this.loadRounds()
        },
        onChangePage(page) {
            this.page = page
            this.loadRounds()
        },
        onFilter(filters) {
            this.filters = filters
            this.loadRounds()
        },
        async deleteRound(item) {
            const rr = { ...roundsRepository }

            try {
                const { data } = await rr.delete(item.id)
                if (data.status) {
                    this.loadRounds()
                } else {
                    toastr.error('No pudo ser eliminada la ronda')
                }
            } catch (err) {
                toastr.error(err.message)
            }
        },
        setupPoint() {
            this.$bus.$emit('control-point-config-window.open')
            this.$refs.controlPointReader.read()
        },
        readerOff() {
            this.$refs.controlPointReader.off()
        },
        onRead(str) {
            this.$bus.$emit('control-point-config-window.close')

            const data = JSON.parse(str)
            if (navigator.geolocation) {
                navigator.geolocation.getCurrentPosition(position => {
                    const latitude = position.coords.latitude
                    const longitude = position.coords.longitude
                    this.sendPointData(data, latitude, longitude)
                })
            }
        },
        async sendPointData(point, latitude, longitude) {
            const rr = { ...roundsRepository }
            try {
                const { data } = await rr.sendControlPointConfig({
                    ...point,
                    latitude,
                    longitude,
                    userId: this.user.id,
                })
                toastr.success(
                    `Punto de control ${point.controlPointName} configurado`
                )
            } catch (err) {
                if (!!err.response && err.response.status === 404) {
                    toastr.error(`No fue encontrado el punto de control`)
                } else {
                    toastr.error(err.message)
                }
            }
        },
    },
    created() {
        this.loadRounds()
    },
}
</script>
